/* ==========================================================================
   Elevate Floors — skin do Shopify Forms

   O app renderiza o formulário dentro de SHADOW DOM, e nenhuma regra do CSS da
   página atravessa essa fronteira. Não é questão de especificidade: o navegador
   isola o conteúdo por design. A única forma de estilizar é injetar uma folha
   dentro do shadowRoot, que é o que este arquivo faz.

   ISTO É FRÁGIL POR NATUREZA, e a fragilidade é conhecida: estamos vestindo a
   estrutura interna de um app de terceiro. Por isso o CSS abaixo mira ELEMENTOS
   e ATRIBUTOS (input[type=email], button[type=submit]) e nunca as classes do
   app — nomes de classe mudam numa atualização sem aviso; um <input type=email>
   continua sendo um input type=email.

   Se um dia o formulário voltar ao visual padrão de repente, foi uma
   atualização do app. O plano B é o setting "Fonte do formulário" na seção:
   trocar para "Formulário do tema" devolve o layout no ato.
   ========================================================================== */
(function () {
  'use strict';

  var CSS = [
    /* :host é o próprio elemento do app, visto de dentro do shadow root — é a
       única forma de alcançá-lo daqui. Ele e o <form> traziam largura máxima
       própria, então alargar o card não fazia efeito nenhum: o conteúdo parava
       antes e a sobra ia toda para a direita. */
    ':host{display:block!important;width:100%!important;max-width:none!important;}',
    /* Regra AMPLA de propósito, e ela vem primeiro: qualquer elemento aqui
       dentro perde limite de largura. Tentei mirar os wrappers um a um e errei
       duas vezes — o app tem mais de uma camada com largura própria, e cada
       tentativa cirúrgica pegava só uma delas.
       As exceções (pílulas, bandeira) reaparecem abaixo e vencem por vir
       depois, com a mesma especificidade. */
    ':host *{max-width:none!important;}',
    'form,form>*,fieldset,fieldset>*{width:100%!important;max-width:none!important;}',

    /* ---------- campos: linha embaixo, não caixa ----------
       O !important daqui para baixo não é preguiça: a folha injetada disputa
       com o CSS interno do app, que mira as próprias classes e por isso vence
       qualquer seletor de elemento no empate de especificidade. Como o objetivo
       é justamente sobrescrever aquele CSS, é o instrumento certo.

       O padding-top é o que separa o texto digitado do rótulo: o app usa rótulo
       FLUTUANTE, que sobe para dentro do campo quando há conteúdo, e o espaço
       entre os dois é justamente o que sobra desse padding. Foi de 10px (as
       duas linhas se sobrepunham) para 20px (encostadas) e agora 28px. Os 10px
       de baixo afastam o texto da linha do campo. */
    'input[type="text"],input[type="email"],input[type="tel"],input[type="number"],',
    'input[type="search"],input[type="url"],textarea,select{',
    '  width:100%!important;background:none!important;border:0!important;',
    '  border-bottom:1px solid rgba(90,72,57,.28)!important;border-radius:0!important;',
    '  padding:28px 0 10px!important;height:auto!important;min-height:0!important;',
    '  font-family:inherit;font-size:15px;line-height:1.5;color:#2B4055;',
    '  box-shadow:none!important;-webkit-appearance:none;appearance:none;',
    '  transition:border-color .25s ease;',
    '}',
    'input:focus,textarea:focus,select:focus{',
    '  outline:none!important;border-bottom-color:#5A4839!important;box-shadow:none!important;',
    '}',
    'textarea{resize:vertical;min-height:52px;}',
    '::placeholder{color:rgba(90,72,57,.45);}',

    /* As caixas quadradas que apareciam ao focar vinham do WRAPPER do campo, não
       do input: o app desenha borda e fundo no container. Zerar só o input não
       alcançava. */
    'div:has(> input),div:has(> textarea),div:has(> select),',
    'label:has(> input[type="text"]),label:has(> input[type="email"]),',
    'label:has(> input[type="tel"]),label:has(> textarea){',
    '  border:0!important;box-shadow:none!important;background:transparent!important;',
    '  outline:none!important;',
    '}',

    /* ---------- rótulos ----------
       O :not() duplo separa os rótulos de CAMPO dos que viram pílula. Sem ele,
       zerar borda e recuo aqui apagaria a pílula, e dar recuo à pílula
       desalinharia o campo — os dois usam <label>, e é a presença do input
       marcável que distingue um do outro.

       Zerar padding e left é o que alinha o rótulo com o texto digitado: eu
       tinha tirado o recuo do input mas o rótulo flutuante manteve o do app,
       então "NAME" nascia uns 30px à direita de "Bruna".

       A borda vinha do mesmo lugar: o app desenha o próprio indicador de foco
       no rótulo, e a caixa aparecia ao clicar no campo. */
    'label:not(:has(input[type="checkbox"])):not(:has(input[type="radio"])){',
    '  font-family:inherit;font-size:12px;font-weight:500;letter-spacing:.1em;',
    '  text-transform:uppercase;color:rgba(90,72,57,.68);',
    '  border:0!important;outline:none!important;box-shadow:none!important;',
    '  background:transparent!important;',
    '  padding-left:0!important;padding-right:0!important;',
    '  left:0!important;margin-left:0!important;',
    '}',
    /* o indicador de foco do app some junto, em qualquer elemento que o receba
       enquanto o campo está ativo */
    'input:focus~label,input:focus+label,label:focus-within{',
    '  border:0!important;outline:none!important;box-shadow:none!important;',
    '}',

    /* ---------- seletor de país do telefone ----------
       Mirado por exclusão: é o único botão do formulário que não é o de enviar.

       Sem caixa, como todo campo daqui — a borda era o que fazia ele parecer um
       bloco solto ao lado do telefone. E o wrapper vira flex alinhado pela BASE,
       que é o que assenta a bandeira na mesma linha do input em vez de deixá-la
       flutuando no topo. */
    /* Também marcado pelo JS (markPhone). O :has() daqui já tinha falhado uma
       vez e o sintoma era este: o seletor não casava, o container seguia como
       grade, e a bandeira ficava numa coluna larga longe do campo. */
    '[data-ef-phone]{',
    '  display:flex!important;align-items:flex-end!important;gap:8px!important;',
    '  grid-template-columns:none!important;width:100%!important;',
    '}',
    /* o input fica com todo o espaço restante; o resto encolhe ao conteúdo */
    '[data-ef-phone]>*{flex:0 0 auto!important;width:auto!important;min-width:0!important;}',
    '[data-ef-phone] input[type="tel"]{flex:1 1 auto!important;width:100%!important;max-width:none!important;}',
    /* o wrapper do telefone parava antes dos demais campos: ele herdava uma
       largura do app que os outros não tinham */
    '[data-ef-phone]>label,[data-ef-phone]>div{flex:1 1 auto!important;max-width:none!important;}',
    /* ...menos a caixa do seletor de país, que deve encolher ao conteúdo. Com
       flex:1 ela reservava ~84px para uma bandeira de 40 e abria um vão entre
       ela e o campo. Marcada pelo JS (markPhone) para não depender de :has(). */
    '[data-ef-phone]>[data-ef-phone-cc]{flex:0 0 auto!important;width:auto!important;min-width:0!important;}',
    '[data-ef-phone] label{flex:1 1 auto!important;}',
    'button:not([type="submit"]){',
    '  width:auto!important;min-width:0!important;height:auto!important;',
    '  flex:0 0 auto!important;align-self:flex-end!important;',
    '  display:inline-flex!important;align-items:center!important;gap:5px!important;',
    '  padding:0 0 9px!important;',
    '  border:0!important;border-radius:0!important;background:transparent!important;',
    '  box-shadow:none!important;',
    '}',
    /* a bandeira e a seta têm tamanhos MUITO diferentes: antes as duas herdavam
       20px e o triângulo ficava do tamanho da bandeira */
    'button:not([type="submit"]) img{width:22px!important;max-width:22px!important;height:auto!important;}',
    'button:not([type="submit"]) svg{',
    '  width:9px!important;height:9px!important;flex:0 0 auto!important;',
    '}',

    /* ---------- pílulas: o input some, o rótulo vira a pílula ----------
       Cobre os dois padrões de markup que o app pode emitir: o input dentro do
       <label> e o input irmão com for/id. Um dos dois casa. */
    /* fora da tela, e não só invisível: absolute sem deslocamento fica na
       posição estática e ainda pode influenciar o layout ao redor */
    'input[type="checkbox"],input[type="radio"]{',
    '  position:absolute!important;left:-9999px!important;',
    '  opacity:0;width:0;height:0;margin:0;padding:0;pointer-events:none;',
    '}',
    /* O CONTAINER das opções vira flex com wrap. O app usa grade de colunas
       fixas, e no celular cada pílula esticava para a largura da célula com o
       texto quebrando dentro — daí as bolas altas do print. Em flex, cada
       pílula tem a largura do próprio texto e a fileira quebra sozinha.
       Mirado pelo pai direto dos rótulos, nas duas formas de markup. */
    /* O container é marcado pelo JS (markPills), não por :has(). O :has()
       dependia de eu acertar a árvore do app às cegas, e quando errava a grade
       continuava de pé: com nowrap ligado, o texto passava por cima da pílula
       vizinha em vez de quebrar. O JS enxerga o DOM real e marca o pai certo. */
    '[data-ef-pills]{',
    '  display:flex!important;flex-wrap:wrap!important;gap:9px!important;',
    '  grid-template-columns:none!important;grid-template-rows:none!important;',
    '}',
    '[data-ef-pills]>*{width:auto!important;max-width:100%!important;}',
    /* Se o app embrulha cada opção num div, esse div vira transparente para o
       layout: display:contents faz o rótulo participar do flex do grupo em vez
       de ficar isolado dentro da própria caixa. */
    '[data-ef-pills]>div:not([data-ef-pills]){display:contents!important;}',
    /* O texto saía torto porque o app reserva um recuo para o checkbox: mesmo
       com o input fora do fluxo, o <span> do rótulo mantinha a margem que
       existia para acomodá-lo, e a pílula ficava com mais ar à esquerda que à
       direita. Zerar espaçamento dos filhos devolve o texto ao centro. */
    '[data-ef-pills] label>*{',
    '  margin:0!important;padding:0!important;',
    '  display:inline!important;line-height:inherit!important;',
    '  text-indent:0!important;',
    '}',
    '[data-ef-pills] label{text-indent:0!important;}',
    '[data-ef-pills] label::before,[data-ef-pills] label::after{',
    '  content:none!important;display:none!important;',
    '}',
    'label:has(input[type="checkbox"]),label:has(input[type="radio"]),',
    'input[type="checkbox"]+label,input[type="radio"]+label{',
    /* inline-BLOCK, não inline-flex: num flex os nós de texto do HTML (inclusive
     um simples espaço antes do rótulo) viram itens anônimos e empurram o
     conteúdo para o lado — era o que deixava o primeiro chip torto, com 48px de
     folga de um lado e 18 do outro. Em inline-block o espaço em branco colapsa
     como texto normal e o text-align centraliza de verdade. */
    '  display:inline-block;text-align:center;cursor:pointer;',
    '  width:auto!important;min-width:0!important;flex:0 1 auto!important;',
    '  max-width:100%!important;white-space:nowrap;',
    '  border:1px solid rgba(90,72,57,.3);border-radius:999px;',
    '  padding:8px 15px;margin:0;',
    '  font-family:inherit;font-size:13px;font-weight:400;letter-spacing:0;',
    '  line-height:1.2;text-transform:none;color:#5A4839;background:transparent;',
    '  transition:background .2s ease,color .2s ease,border-color .2s ease;',
    '}',
    /* O texto do chip selecionado ficava preto: o rótulo do app envolve o texto
       num <span> próprio, e a cor dele vencia a do <label>. O seletor de
       descendente pinta o span junto. */
    'label:has(input[type="checkbox"]:checked),label:has(input[type="radio"]:checked),',
    'input[type="checkbox"]:checked+label,input[type="radio"]:checked+label{',
    '  background:#5A4839!important;border-color:#5A4839!important;color:#F5EEE6!important;',
    '}',
    'label:has(input[type="checkbox"]:checked) *,label:has(input[type="radio"]:checked) *,',
    'input[type="checkbox"]:checked+label *,input[type="radio"]:checked+label *{',
    '  color:#F5EEE6!important;',
    '}',
    'label:has(input:focus-visible),input:focus-visible+label{',
    '  outline:2px solid #5A4839;outline-offset:3px;',
    '}',

    /* ---------- botão ---------- */
    'button[type="submit"],input[type="submit"]{',
    '  background:#5A4839;color:#F5EEE6;border:0;border-radius:999px;',
    '  padding:16px 34px;width:auto!important;height:auto;',
    '  font-family:inherit;font-size:12.5px;font-weight:500;',
    '  letter-spacing:.11em;text-transform:uppercase;',
    '  cursor:pointer;transition:background .25s ease;',
    '}',
    'button[type="submit"]:hover,input[type="submit"]:hover{background:#2B4055;}',

    /* o app costuma pintar o próprio fundo no container; aqui o card já é
       nosso, então o dele precisa sair para não criar uma caixa dentro da caixa */
    'form,section,div{background:transparent;}',

    /* ---------- a faixa branca atrás do rótulo ----------
       O app pinta um ::before branco atrás do rótulo flutuante, para ele não
       cruzar a linha do campo. Isso pressupõe formulário sobre fundo BRANCO —
       aqui o card é creme, e a faixa aparecia como um retângulo claro acima do
       "Project details". Nos campos de uma linha ela nasce transparente; só a
       área de texto vinha pintada.

       Seletor por pedaço do nome da classe porque o app embaralha o sufixo
       (CSS Modules) a cada build dele: `_formFieldContainer_1mxsl_5` hoje,
       outro amanhã. */
    '[class*="_formFieldContainer_"]::before,',
    '[class*="_formPhoneInputContainer_"]::before{',
    '  background:transparent!important;',
    '}',

    /* ---------- mensagens de validação ----------
       O app pendura a mensagem como IRMÃ do campo, não dentro dele, e ela
       sempre atravessa a grade inteira. Em duas colunas isso desalinhava tudo:
       a mensagem do nome quebrava a linha, telefone e e-mail se emparelhavam
       fora de ordem, e a mensagem do e-mail aparecia embaixo do telefone. O JS
       (markGrid) marca a mensagem e alarga o campo dela; aqui fica só a
       aparência. */
    '[data-ef-error]{',
    '  display:block!important;width:100%!important;',
    '  margin:6px 0 0!important;padding:0!important;',
    '  font-family:inherit!important;font-size:13px!important;line-height:1.35!important;',
    '  color:#B3261E!important;text-align:left!important;',
    '}',
    /* No telefone a mensagem nasce DENTRO do campo, que é flex em linha: sem
       permitir a quebra ela fica ao lado do input, invadindo o campo vizinho. */
    '[data-ef-phone]{flex-wrap:wrap!important;}',
    '[data-ef-phone] [data-ef-error]{flex:1 0 100%!important;margin-top:4px!important;}',

    /* ---------- duas colunas no desktop ----------
       750px e não 900: o corte aqui é a largura do CARD, não da janela. Abaixo
       disso duas colunas deixariam cada campo estreito demais para o texto
       digitado, que é pior que empilhar. */
    '@media (min-width:750px){',
    '  [data-ef-fields]{',
    '    display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;',
    '    gap:14px 26px!important;align-items:end!important;',
    '  }',
    '  [data-ef-wide]{grid-column:1 / -1!important;}',
    '}',

    /* No celular o card é estreito e "Hardwood install" é o rótulo mais longo.
       Com nowrap ligado, sem encolher a fonte ele estouraria a linha em vez de
       quebrar dentro da pílula — troca um defeito pelo outro. */
    '@media (max-width:600px){',
    '  label:has(input[type="checkbox"]),label:has(input[type="radio"]),',
    '  input[type="checkbox"]+label,input[type="radio"]+label{',
    '    font-size:12px;padding:7px 12px;',
    '  }',
    '  [data-ef-pills]{gap:7px!important;}',
    '}'
  ].join('\n');

  function inject(host) {
    var root = host.shadowRoot;
    if (!root || root._efSkinned) return;
    root._efSkinned = true;

    // adoptedStyleSheets é o caminho limpo: não insere nó e sobrevive a
    // re-render interno do app. O <style> fica de reserva para navegadores
    // antigos.
    if ('adoptedStyleSheets' in root && typeof CSSStyleSheet === 'function') {
      try {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
        root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
        return;
      } catch (e) { /* cai no fallback */ }
    }
    var st = document.createElement('style');
    st.textContent = CSS;
    root.appendChild(st);
  }

  /* Marca o container das opções a partir do input, subindo até o pai do
     rótulo. É o caminho inverso do CSS: em vez de descrever a árvore e torcer
     para acertar, parte do elemento que com certeza existe — o input marcável —
     e chega no container por navegação. */
  function markPills(root) {
    root.querySelectorAll('input[type="checkbox"],input[type="radio"]').forEach(function (inp) {
      var label = inp.closest('label');
      if (!label && inp.id) {
        try { label = root.querySelector('label[for="' + CSS_escape(inp.id) + '"]'); } catch (e) {}
      }

      /* Sobe até um ancestral que contenha DUAS ou mais opções. O pai direto do
         rótulo não serve: quando o app embrulha cada opção num div próprio, ele
         é o pai — e marcá-lo transformava a opção sozinha num flex de um item
         só, que perdia a forma de pílula. Era o caso do primeiro chip. */
      var el = (label || inp).parentElement, hops = 0;
      while (el && hops < 4) {
        if (el.querySelectorAll('input[type="checkbox"],input[type="radio"]').length >= 2) {
          el.setAttribute('data-ef-pills', '');
          return;
        }
        el = el.parentElement;
        hops++;
      }
    });
  }
  /* Sobe do input do telefone até o ancestral que também contém o seletor de
     país, e marca esse. Cinco níveis é folga suficiente para qualquer wrapper
     que o app use, sem sair do campo. */
  function markPhone(root) {
    root.querySelectorAll('input[type="tel"]').forEach(function (inp) {
      var el = inp.parentElement, hops = 0;
      while (el && hops < 5) {
        var pais = el.querySelector('button:not([type="submit"])');
        if (pais) {
          el.setAttribute('data-ef-phone', '');
          /* A caixa em volta da bandeira, para o CSS poder encolhê-la. Tem de
             ser o filho DIRETO do container: é ele que participa do flex e que
             carrega a largura fixa vinda do app. Marcar o div de dentro não
             adiantava — ele só acompanhava o pai. */
          Array.prototype.forEach.call(el.children, function (filho) {
            if (filho.contains(pais)) filho.setAttribute('data-ef-phone-cc', '');
          });
          return;
        }
        el = el.parentElement;
        hops++;
      }
    });
  }

  /* Duas colunas nos campos de texto, como no formulário do tema.

     Marca o container comum e, dentro dele, quem NÃO deve dividir a linha:
     os grupos de pílula, o campo de detalhes (textarea) e os rótulos soltos.
     Tudo o mais cai em duas colunas na ordem em que já está — o que dá
     Name | Phone e Email | Address sem reordenar nada. */
  function markGrid(root) {
    var TEXTS = 'input[type="text"],input[type="email"],input[type="tel"],input[type="number"],textarea';

    var first = root.querySelector(TEXTS);
    if (!first) return;

    var el = first.parentElement, hops = 0, box = null;
    while (el && hops < 5) {
      if (el.querySelectorAll(TEXTS).length >= 2) { box = el; break; }
      el = el.parentElement;
      hops++;
    }
    if (!box) return;
    box.setAttribute('data-ef-fields', '');

    /* A mensagem de validação é um <output>. Marcar todas de uma vez — inclusive
       a que nasce dentro do campo de telefone — evita depender do nome da classe
       do app, que vem embaralhado pelo CSS Modules e muda a cada build dele. */
    root.querySelectorAll('output').forEach(function (o) {
      o.setAttribute('data-ef-error', '');
    });

    Array.prototype.forEach.call(box.children, function (child) {
      var isPills = child.hasAttribute('data-ef-pills') ||
                    child.querySelector('input[type="checkbox"],input[type="radio"]');
      var isArea = !!child.querySelector('textarea');
      var hasText = !!child.querySelector(TEXTS);

      if (isPills || isArea || !hasText) child.setAttribute('data-ef-wide', '');
      else child.removeAttribute('data-ef-wide');
    });

    /* Campo com mensagem de erro passa a ocupar a linha inteira, para a
       mensagem cair exatamente debaixo DELE. É o que desfaz o emparelhamento
       torto: sem isto, o campo seguinte sobe para a coluna vizinha e a mensagem
       parece pertencer a outro campo. Quando o erro some, markGrid roda de novo
       (o observer do shadow root dispara a cada re-render) e o campo volta a
       dividir a linha. */
    Array.prototype.forEach.call(box.children, function (child) {
      if (!child.hasAttribute('data-ef-error')) return;
      child.setAttribute('data-ef-wide', '');
      if (child.previousElementSibling) {
        child.previousElementSibling.setAttribute('data-ef-wide', '');
      }
    });
  }

  /* Marca sozinho o chip do serviço da página, uma vez só.

     O clique é simulado no input em vez de escrever .checked = true: o app tem
     estado interno próprio, e mexer na propriedade direto muda a caixa sem o
     app ficar sabendo — o lead chegaria sem o serviço, que é pior que não
     pré-selecionar nada.

     E acontece UMA vez: sem o guard, o MutationObserver remarcaria a cada
     re-render e a pessoa não conseguiria desmarcar. */
  function preselect(root, wanted) {
    if (!wanted || root._efPreselected) return;

    var alvo = wanted.trim().toLowerCase();
    var achou = false;

    root.querySelectorAll('input[type="checkbox"],input[type="radio"]').forEach(function (inp) {
      if (achou || inp.checked) return;
      var label = inp.closest('label');
      if (!label && inp.id) {
        try { label = root.querySelector('label[for="' + CSS_escape(inp.id) + '"]'); } catch (e) {}
      }
      var texto = (label ? label.textContent : (inp.value || '')).trim().toLowerCase();
      if (texto === alvo) {
        inp.click();
        achou = true;
      }
    });

    if (achou) root._efPreselected = true;
  }

  function CSS_escape(v) {
    return (window.CSS && CSS.escape) ? CSS.escape(v) : v.replace(/([^\w-])/g, '\\$1');
  }

  /* Varre por QUALQUER elemento com shadowRoot dentro do nosso wrapper, em vez
     de procurar a tag do app pelo nome. O nome do custom element é detalhe de
     implementação do Shopify Forms e pode mudar; ter um shadowRoot, não. */
  /* o valor vem do wrapper da seção, escrito pelo Liquid a partir do setting */
  function scopeOf(el) {
    var w = el.closest('[data-ef-forms-skin]');
    return w ? (w.getAttribute('data-ef-preselect') || '') : '';
  }

  function scan(scope) {
    scope.querySelectorAll('*').forEach(function (el) {
      if (!el.shadowRoot) return;
      inject(el);
      markPills(el.shadowRoot);
      markPhone(el.shadowRoot);
      markGrid(el.shadowRoot);
      preselect(el.shadowRoot, scopeOf(el));

      /* O observer de fora não enxerga mudanças DENTRO do shadow root, e o app
         re-renderiza as opções ao interagir. Sem este, a marcação se perderia
         no primeiro clique. */
      if (!el.shadowRoot._efPillObserver) {
        el.shadowRoot._efPillObserver = new MutationObserver(function () {
          markPills(el.shadowRoot);
          markPhone(el.shadowRoot);
          markGrid(el.shadowRoot);
          preselect(el.shadowRoot, scopeOf(el));
          conferirSucesso(el.shadowRoot);
        });
        el.shadowRoot._efPillObserver.observe(el.shadowRoot, { childList: true, subtree: true });
      }
    });
  }

  /* ======================================================================
     REDIRECIONAMENTO DEPOIS DO ENVIO

     O destino vem do setting da seção (data-ef-redirect no wrapper). Sem
     valor, nada acontece e o app segue mostrando a mensagem dele.

     São DOIS sinais independentes, porque um formulário que não redireciona
     é uma venda perdida silenciosa:

       1. REDE — o envio é um POST para forms.shopifyapps.com. Resposta 2xx
          significa recebido. É o sinal mais confiável, e chega antes de
          qualquer mudança na tela.
       2. TELA — o app troca o formulário pela mensagem de sucesso. Quando os
          campos somem do shadow root, o envio deu certo. Cobre o caso de o
          app mudar de endereço, passar a usar sendBeacon ou responder por um
          caminho que o item 1 não veja.

     Os dois só valem DEPOIS de a pessoa ter enviado (tentouEnviar), e o
     redirecionamento acontece uma vez só. Sem isso, um POST de telemetria do
     app no carregamento da página levaria a pessoa para a página de obrigado
     sem ela ter feito nada.
     ====================================================================== */
  var ALVO = /forms\.shopifyapps\.com/i;
  var tentouEnviar = false;
  var jaRedirecionou = false;

  function destino() {
    var w = document.querySelector('[data-ef-forms-skin][data-ef-redirect]');
    var v = w && w.getAttribute('data-ef-redirect');
    return v && v.trim() ? v.trim() : '';
  }

  function redirecionar(motivo) {
    if (jaRedirecionou || !tentouEnviar) return;
    var url = destino();
    if (!url) return;
    jaRedirecionou = true;
    /* O pequeno atraso é para o Google Tag Manager e o pixel do app terem o
       quadro seguinte para registrar o envio: sair da página no mesmo
       instante corta esse registro pela metade. */
    setTimeout(function () {
      try { sessionStorage.setItem('ef-thanks-de', location.pathname + ' (' + motivo + ')'); } catch (e) {}
      location.assign(url);
    }, 350);
  }

  /* Qualquer clique ou Enter dentro do formulário conta como tentativa. Os
     eventos de dentro do shadow root chegam aqui porque sobem compostos; o
     'submit', não, e é por isso que a marcação é feita por clique/tecla. */
  function marcaTentativa(e) {
    if (jaRedirecionou) return;
    var caminho = (e.composedPath && e.composedPath()) || [];
    for (var i = 0; i < caminho.length; i++) {
      var n = caminho[i];
      if (n && n.nodeType === 1 && n.hasAttribute && n.hasAttribute('data-ef-forms-skin')) {
        tentouEnviar = true;
        return;
      }
    }
  }
  document.addEventListener('click', marcaTentativa, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') marcaTentativa(e);
  }, true);

  /* ---- sinal 1: a resposta do envio ---- */
  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function') {
    window.fetch = function (entrada, opcoes) {
      var resposta = fetchOriginal.apply(this, arguments);
      try {
        var url = (entrada && entrada.url) || String(entrada || '');
        var metodo = ((opcoes && opcoes.method) || (entrada && entrada.method) || 'GET').toUpperCase();
        if (metodo === 'POST' && ALVO.test(url)) {
          resposta.then(function (r) {
            if (r && (r.ok || r.status === 0)) redirecionar('rede');
          }, function () {});
        }
      } catch (e) {}
      return resposta;
    };
  }

  var abrirOriginal = XMLHttpRequest.prototype.open;
  var enviarOriginal = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    try {
      this._efPost = String(metodo || '').toUpperCase() === 'POST' && ALVO.test(String(url || ''));
    } catch (e) {}
    return abrirOriginal.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._efPost) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) redirecionar('rede');
      });
    }
    return enviarOriginal.apply(this, arguments);
  };

  /* ---- sinal 2: o formulário sai da tela ----
     Chamado pelo observer de cada shadow root (ver scan). Campos ainda na
     tela significam erro de validação, não sucesso — por isso a checagem é
     pela AUSÊNCIA deles. */
  function conferirSucesso(root) {
    if (jaRedirecionou || !tentouEnviar || !destino()) return;
    if (root.querySelector('input,textarea,select')) return;
    if (!root.textContent || !root.textContent.trim()) return;   // ainda re-renderizando
    redirecionar('tela');
  }

  function init() {
    var wraps = document.querySelectorAll('[data-ef-forms-skin]');
    if (!wraps.length) return;

    wraps.forEach(function (w) {
      scan(w);
      if (w._efSkinObserver) return;
      // O app monta o formulário depois do carregamento da página, então uma
      // varredura única erraria o alvo na maioria das vezes.
      w._efSkinObserver = new MutationObserver(function () { scan(w); });
      w._efSkinObserver.observe(w, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
